import { FormComponent } from "../../../react-core/Html/FormComponent";
import * as React from "react";
import { PartLoading } from "../../../react-core/Html/PartLoading";
import { getQueryParameters } from "../Wizards/Entities/QueryParametersHelper";
import { IProcessProps, IStepConfig, Process } from "./Process/Process";
import { uniq } from "lodash";
import { Lightbox } from "../../../react-core/Html/Components/Lightbox";

export interface IWizardComponentStateGeneric {
    data: any;
    errorMsg: string[];
    isLoading: boolean;
    isShowErrorMsg: boolean;
    onPosting?: boolean;
    active?: boolean;
    isSubmitting?: boolean;
    showSaveAndExitLightbox?: boolean;
    hasPassBeforeExit?: boolean;
    saveFrom?: number;
}

export abstract class WizardComponentGeneric<TState extends IWizardComponentStateGeneric> extends FormComponent<
    null,
    TState
> {
    constructor(props: any) {
        super(props);
        this.initState();
    }

    protected stepperConfig: IStepConfig[] = [];
    protected child: any = {};

    protected onChange(changes) {
        const { data } = this.state;
        const _data = JSON.parse(JSON.stringify(data));
        for (const key in changes) {
            _data[key] = JSON.parse(JSON.stringify(changes[key]));
        }
        this.setState({ errorMsg: [], isShowErrorMsg: false });
        this.setState({ data: _data });
    }

    protected getNextStepUrls(to) {
        if (this.stepperConfig[to]) {return this.stepperConfig[to].url;}
        return this.stepperConfig[0].url;
    }

    protected stepValid(step) {
        return this.child[step].isValid();
    }

    protected onStepperLeave(from, to): void {
        if (!this.state.active && to == -1) {return this.onExit();}
        const stepLength = this.stepperConfig.length;
        if (from == stepLength - 1 && (to > from || to == -1)) {return this.onExit();}
        let isPass = false;

        //save & exit
        if (to == -1 && this.state.active) {
            isPass = this.child[from]?.isValid();
            this.setState({ showSaveAndExitLightbox: true, hasPassBeforeExit: isPass, saveFrom: from });
            return;
        }
        if (from > to || !this.state.active) {
            isPass = true;
        } else {
            isPass = this.child[from]?.isValid();
        }
        const params = getQueryParameters();
        const url = this.getNextStepUrls(to);
        if (isPass) {
            this.setState({ onPosting: true });
            this.saveInstruction(from, to, url, params, stepLength);
        } else {
            this.setState((preState) => ({ isShowErrorMsg: preState.errorMsg.length > 0 }));
        }
    }
    abstract initState();

    abstract saveInstruction(from, to, toUrl, params, stepLength);

    abstract onCancel();

    abstract onExit();

    abstract onSubmit();

    protected getStepProps(index) {
        const { data, active } = this.state;
        return {
            isReview: !active,
            data: JSON.parse(JSON.stringify(data)),
            onRef: (ref) => (this.child[index] = ref),
            onChange: (changes) => this.onChange(changes),
            showErrorMsgPopUp: (msg, showNow?) =>
                this.setState((preState) => ({
                    errorMsg: uniq(preState.errorMsg.concat(msg)),
                    isShowErrorMsg: showNow,
                })),
        };
    }

    abstract setStepperConfig();

    protected setProcessProps(): IProcessProps {
        return {
            onPosting: this.state.onPosting,
            stepsConfig: this.stepperConfig,
            onSave: (from) => this.onStepperLeave(from, -1),
            onCancel: () => this.onCancel(),
            processTitle: "",
            goBacktoFirst: false,
            active: this.state.active,
            isShowError: this.state.isShowErrorMsg,
            errorMsg: this.state.errorMsg,
            needSplitHeader: {
                fromStep: 0,
                splitHeaderMain: "",
                splitHeaderSub: "",
            },
            onClearError: () => this.setState({ isShowErrorMsg: false, errorMsg: [] }),
        };
    }

    protected wizardRender() {
        if (this.state.isLoading) {return <PartLoading isLoading={true} />;}
        this.setStepperConfig();
        return (
            <>
                <Process {...this.setProcessProps()} />
            </>
        );
    }

    protected customeRender() {}

    render() {
        return (
            <>
                {this.wizardRender()}
                {this.customeRender()}
                {this.state.showSaveAndExitLightbox && (
                    <Lightbox
                        title="Save & exit"
                        show={this.state.showSaveAndExitLightbox}
                        cssWrapper="is-default-lightbox"
                        onClose={() => this.setState({ showSaveAndExitLightbox: false })}
                    >
                        <div className="mb-40">
                            {this.state.hasPassBeforeExit
                                ? "Are you sure you want to exit from this journey?"
                                : "In order to save all the data from the current page of the journey, you need to complete all mandatory fields.  All completed pages have been automatically saved.  If you choose to exit now you will lose all data entered on current page. "}
                        </div>

                        {this.state.hasPassBeforeExit ? (
                            <>
                                <button
                                    className="btn secondary mr-10"
                                    onClick={() => this.setState({ showSaveAndExitLightbox: false })}
                                >
                                    No
                                </button>
                                <button
                                    className={`btn primary mr-10 ${this.state.onPosting ? "is-busy" : ""}`}
                                    onClick={() => {
                                        const params = getQueryParameters();
                                        const url = this.getNextStepUrls(-1);
                                        const stepLength = this.stepperConfig.length;
                                        this.setState({ onPosting: true });
                                        this.saveInstruction(this.state.saveFrom, -1, url, params, stepLength);
                                    }}
                                >
                                    Yes
                                </button>
                            </>
                        ) : (
                            <>
                                <button
                                    className="btn secondary mr-5"
                                    onClick={() => this.setState({ showSaveAndExitLightbox: false })}
                                >
                                    Return
                                </button>
                                <button className="btn primary mr-5" onClick={() => this.onExit()}>
                                    Exit
                                </button>
                            </>
                        )}
                    </Lightbox>
                )}
            </>
        );
    }
}
